import React from "react";
import AppRouter from "./AppRouter";
import { Provider } from "react-redux";
import { store } from "./redux/setup/setupStore";
import { BrowserRouter } from "react-router-dom";

import "moment/locale/nl.js";

import "./App.scss";

function App() {
    return (
        <Provider store={store}>
            <BrowserRouter>
                <AppRouter />
            </BrowserRouter>
        </Provider>
    );
}

export default App;
